import { Card, Flex } from "antd"

import InfoTooltip from "../../../Components/InfoTooltip/InfoTooltip"

// Boxed dashboard section using the EXACT Prevent chart-card style
// (.card-chart-wrapper.withTitle: radius 24, head padding 24, headerless border).
// title goes in the card head (left), optional control as `extra` (right).
// `autoHeight` opts out of the stretch: the card ends where its content ends, instead of
// growing to match the taller card beside it. Use it where the content has its own natural
// height (a short bar list, a 5-row heat map) and the filler space read as a bug.
const Section = ({ title, tooltip, extra, children, minHeight, autoHeight, className = "" }) => (
  <Card
    className={`card-chart-wrapper withTitle ${className}`.trim()}
    styles={{ header: { border: "none" } }}
    // height:100% + the page Row align="stretch" makes paired 2-up cards equal
    // height (matching Alerts Analytics), even when one has less content.
    style={{ ...(autoHeight ? {} : { height: "100%" }), ...(minHeight ? { minHeight } : {}) }}
    title={
      tooltip ? (
        <Flex align="center" gap={8}>
          <span>{title}</span>
          <InfoTooltip title={tooltip} placement="top" />
        </Flex>
      ) : (
        title
      )
    }
    extra={extra}
  >
    {children}
  </Card>
)

export default Section
